import { __awaiter, __generator } from 'tslib';

function importResponsibleGaming() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import(
                    /* webpackChunkName: "responsible-gaming" */
                    '@gig/magic-responsible-gaming')];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}

export { importResponsibleGaming };
